import { all, call } from 'redux-saga/effects';
import ceaseSagas from 'CustomerRequests/Cease/sagas';

export default function* rootSaga() {
  yield all([call(ceaseSagas)]);
}
